import { render, staticRenderFns } from "./homeButton.vue?vue&type=template&id=6f373f7b&scoped=true"
import script from "./homeButton.vue?vue&type=script&lang=js"
export * from "./homeButton.vue?vue&type=script&lang=js"
import style0 from "./homeButton.vue?vue&type=style&index=0&id=6f373f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f373f7b",
  null
  
)

export default component.exports